import { AppShell, Burger, Tooltip, Transition } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { ProfBurger } from './ProfBurger';
import { StudBurger } from './StudBurger';

export function AppNavbar(props) {
    const [opened, { toggle }] = useDisclosure();

    return (
        <AppShell 
            header={{ height: 60 }}
            navbar={{
                width: 300,
                breakpoint: 'sm',
                collapsed: { mobile: !opened },
            }}
            withBorder={false}
            padding="md"
        >
            <AppShell.Header style={{ display: 'flex', alignItems: 'center', backgroundColor: 'rgb(13, 82, 44)', color: 'white' }}>
                {props.isLoggedIn && (
                    <Tooltip label="Meniu" transitionProps={{
                        duration: 250,
                        timingFunction: 'ease-out',
                        transition: 'slide-down',
                    }}>
                        <Burger
                            color='white'
                            opened={opened}
                            onClick={toggle}
                            size="sm"
                            style={{ marginLeft: '16px' }}
                        /></Tooltip>
                )}
                <img
                    src="https://bt.ase.ro/wp-content/uploads/2022/01/cropped-logo_FBT.png"
                    style={{ width: 50, marginRight: '16px', marginLeft: '10px' }} alt="logo"
                />
                <div>
                    {props.isLoggedIn && 'Licență B.T.'}
                    {!props.isLoggedIn &&
                        'Facultatea de Business și Turism'}
                </div>
            </AppShell.Header>
            {opened && (
                <AppShell.Navbar p="md" withBorder>
                    {props.isLoggedIn && !props.isStudent && <ProfBurger close={toggle}/>}
                    {props.isLoggedIn && props.isStudent && <StudBurger close={toggle}/>}
                </AppShell.Navbar>
            )}
        </AppShell>

    );
}